import React, { useState } from 'react';
import { Reveal } from './ui/Reveal';
import { Plus } from 'lucide-react';
import { useSiteContent } from '../contexts/SiteContentContext';
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const {
    content
  } = useSiteContent();
  const faq = content.faq;
  return <section id="faq" className="py-24 px-6 md:px-16 bg-sand" data-id="element-985">
      <div className="max-w-3xl mx-auto" data-id="element-986">
        <Reveal className="text-center mb-12" data-id="element-987">
          <span className="inline-block bg-sage-light/30 text-earth text-xs font-semibold uppercase tracking-widest px-3.5 py-1.5 rounded-full mb-4" data-id="element-988">
            {faq.sectionLabel}
          </span>
          <h2 className="font-display text-4xl md:text-5xl text-earth" data-id="element-989">
            {faq.sectionTitle}
          </h2>
        </Reveal>

        <div className="flex flex-col gap-3" data-id="element-990">
          {faq.items.map((item, i) => {
          const isOpen = openIndex === i;
          return <Reveal key={i} delay={i * 50} data-id="element-991">
                <div className={`bg-white rounded-2xl border border-earth/5 overflow-hidden transition-all duration-300 ${isOpen ? 'shadow-sm' : ''}`} data-id="element-992">
                  <button className="w-full flex justify-between items-center p-5 md:px-6 text-left font-semibold text-[0.95rem] text-earth" onClick={() => setOpenIndex(isOpen ? null : i)} data-id="element-993">
                    {item.q}
                    <div className={`w-7 h-7 rounded-full flex items-center justify-center shrink-0 transition-all duration-300 ${isOpen ? 'bg-sage text-white rotate-45' : 'bg-sand text-earth'}`} data-id="element-994">
                      <Plus size={16} data-id="element-995" />
                    </div>
                  </button>
                  <div className={`overflow-hidden transition-all duration-400 ease-in-out ${isOpen ? 'max-h-[300px] opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-996">
                    <div className="px-5 md:px-6 pb-5 text-sm text-stone leading-relaxed" data-id="element-997">
                      {item.a}
                    </div>
                  </div>
                </div>
              </Reveal>;
        })}
        </div>
      </div>
    </section>;
}